'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — Technology product & community operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Product & community pulse',
  kpis: [
    { val: '1,930', lbl: 'Live mentions', live: true },
    { val: '88', lbl: 'Open escalations' },
    { val: '3.1m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 38, tone: 'positive' },
    { lbl: 'Neutral', pct: 34, tone: 'neutral' },
    { lbl: 'Negative', pct: 28, tone: 'negative' },
  ],
  sla: { pct: 80, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'D', text: 'Critical bug after latest update', handle: '@dev_arora', tag: 'Bug', tagLevel: 'high' },
    { letter: 'S', text: 'Service down for our team', handle: '@sara_k', tag: 'Outage', tagLevel: 'high' },
    { letter: 'A', text: 'Billing charged twice this month', handle: '@amit_v', tag: 'Billing', tagLevel: 'med' },
    { letter: 'R', text: 'Promised feature still missing', handle: '@riya_n', tag: 'Product', tagLevel: 'med' },
  ],
  chips: [
    { variant: 'light', title: 'Adoption risk', sub: 'Dev sentiment dipping on launch' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Outage → on-call in 2s' },
  ],
};

export default function TechnologyHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Technology'),
      }}
      title={
        <>
          {t('industries_technology.your_community_is_your_moat_the')}{' '}
          <span className="serif-accent italic">{t('industries_technology.technology_brand_reputation_managem')}</span>
          {' '}{t('industries_technology.for')}{' '}
          <span className="serif-accent italic">{t('industries_technology.saas_it_firms_tech_startups')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_technology.technology_brands_live_and_die_by_w')}{' '}
          <span style={BLUE}>{t('industries_technology.g2_review')}</span> {t('industries_technology.thread_that_trends_negatively_a_red')}{' '}
          <span style={DEEP}>{t('industries_retail_ecommerce.locobuzz_intercepts_all_three')}</span>
        </>
      }
      actions={
        <BookDemoButton label={t('industries_technology.book_a_personalised_technology_bran')} />
      }
      visual={<IndustryCommandCentre ariaLabel="Technology product and community command centre" {...CC} />}
    />
  );
}
